<div class="flex h-screen w-full items-center justify-center bg-white dark:bg-vivid-royal-950">
  <div class="w-full max-w-md px-6 py-10">

    <!-- Logo -->
    <div class="mb-8 text-center">
      <img src="./assets/logos/energo_logo.svg" class="mx-auto w-40 dark:hidden" alt="Logo" />
      <img src="./assets/logos/energo_logo_dark.svg" class="mx-auto w-40 hidden dark:block" alt="Logo" />
    </div>

    <!-- Loading -->
    @if(enProceso) {
      <div class="text-center py-10">
        <i class="pi pi-spin pi-spinner text-2xl text-vivid-royal-400"></i>
        <p class="text-sm text-vivid-royal-400 mt-3">Procesando desvinculación...</p>
      </div>
    }

    <!-- Success -->
    @if(showResponse && showSuccess && !enProceso) {
      <div class="text-center space-y-4">
        <div class="w-16 h-16 rounded-full bg-green-100 dark:bg-green-900/30 flex items-center justify-center mx-auto">
          <i class="pi pi-check text-3xl text-green-500"></i>
        </div>
        <h1 class="text-xl font-semibold text-vivid-royal-700 dark:text-vivid-royal-100">Dispositivo desvinculado</h1>
        <p class="text-sm text-vivid-royal-400">El conductor o usuario podrá ingresar nuevamente a la APP desde otro dispositivo.</p>
      </div>
    }

    <!-- Error -->
    @if(showResponse && !showSuccess && !enProceso) {
      <div class="text-center space-y-4">
        <div class="w-16 h-16 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center mx-auto">
          <i class="pi pi-times text-3xl text-red-500"></i>
        </div>
        <h1 class="text-xl font-semibold text-vivid-royal-700 dark:text-vivid-royal-100">No se pudo desvincular</h1>
        <p class="text-sm text-vivid-royal-400">Intente de nuevo o contacte a su administrador.</p>
      </div>
    }

    <!-- Unlink button -->
    @if(!showResponse && !enProceso && !showOtp) {
      <div class="text-center space-y-6">
        <div class="w-16 h-16 rounded-full bg-vivid-royal-100 dark:bg-vivid-royal-800 flex items-center justify-center mx-auto">
          <i class="pi pi-link text-2xl text-vivid-royal-500 dark:text-vivid-royal-300" style="text-decoration: line-through;"></i>
        </div>
        <h1 class="text-xl font-semibold text-vivid-royal-700 dark:text-vivid-royal-100">Desvincular dispositivo</h1>

        <div class="bg-amber-50 dark:bg-amber-900/20 border border-amber-300 dark:border-amber-700 rounded-lg p-4 text-left">
          <div class="flex items-start gap-2">
            <i class="pi pi-exclamation-triangle text-amber-500 mt-0.5"></i>
            <p class="text-xs text-amber-700 dark:text-amber-300">
              Al desvincular este dispositivo, el conductor o usuario podrá ingresar a la APP desde un nuevo dispositivo.
            </p>
          </div>
        </div>

        <button pButton label="Desvincular" icon="pi pi-times-circle" class="p-button-sm p-button-outlined w-full" (click)="sendUnlink()"></button>
      </div>
    }
  </div>
</div>

@if(showOtp) {
  <app-auth-code-form-user [phoneNumber]="''" [email]="this.dataSend" [clientNumber]="client"
    [dialcode]="'52'" (closeModal)="closeForm($event)" [IsPhone]="true" (validate)="closeForm($event)"
    [isRecovery]="false" [isBlock]="false" [info]="token" [isActivate]="false" [isDriver]="false" [isUnlink]="true">
  </app-auth-code-form-user>
}
